import {EsignatureTemplate} from "../../Types.ts";
import {CURRENT_REGION} from "../../utils/region";
import jsonApi from "../jsonApi.ts";

export async function list(): Promise<EsignatureTemplate[]> {
  return await jsonApi.get<EsignatureTemplate[]>(`/region/${CURRENT_REGION}/api/vendor_toolkit/esignature_templates`);
}
